import { memo } from 'react';
import Skeleton from '@mui/material/Skeleton';

const UploaderSkeleton = () => <Skeleton variant='rounded' width={128} height={128} />;

export default memo(UploaderSkeleton);